export const endpoints = {
  metadata: (id: number) => `optionsCollection/${id}/metadata`,
  codetablesAccess: 'optionsCollection/access',
  codesAccess: (codetableId: number) => `optionsCollection/${codetableId}/code/access`
};
